import CollectionPageRouter from 'views/Nft/market/Collection/CollectionPageRouter'

// Static shell: collection data loads client-side, so no server render or ISR on Vercel.
const CollectionPage = () => {
  return <CollectionPageRouter />
}

export default CollectionPage
